import React, { useState, useEffect } from "react";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Collapse,
  Tag,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import IMAGES from "../../../../../constant/images";
import { ArrowLeft } from "lucide-react";
import "./style.css";
import MemberUpload from "../../../components/BulkUpload/MemberUpload";
import { useDispatch, useSelector } from "react-redux";
import { getAttributesApi } from "../../../../../redux/action/Attributes";
import moment from "moment";
import { createMemberApi } from "../../../../../redux/action/Member";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const dispatch = useDispatch();
  const { attributes, attributeLoading, attributeError } = useSelector(
    (state) => state.GET_ATTRIBUTES
  );
  const { createMember, createMemberLoading, createMemberError } = useSelector(
    (state) => state.CREATE_MEMBER
  );

  const { Option } = Select;
  const { Panel } = Collapse;
  const [collapsed, setCollapsed] = useState(false);
  const [form] = Form.useForm();
  const [customGroups, setCustomGroups] = useState(["Student", "1st year"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [groups, setGroups] = useState([]);
  const [dobValue, setDobValue] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!createMemberLoading) {
      if (createMember && !createMemberError) {
        message.success("Member created successfully!");
        form.resetFields();
        navigate("/members"); // ✅ redirect to members list
      }

      if (createMemberError) {
        message.error(createMemberError);
      }
    }
  }, [createMember, createMemberError, createMemberLoading, form]);

  const handleCustomGroupChange = (value) => {
    setCustomGroups(value);
  };

  const handleFinish = (values) => {
    let payload = JSON.stringify({
      title: values.title,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      mobile_number: values.phone,
      dob: moment(dobValue || null).format("YYYY-MM-DD"),
      departmentIds: values?.department,
      clientLocationIds: values?.location,
      groupIds: values?.customGroup,
    });
    dispatch(createMemberApi(payload));
  };

  const getAttributes = () => {
    dispatch(getAttributesApi());
  };

  useEffect(() => {
    getAttributes();
  }, []);

  const filterAttributes = () => {
    const extractItems = (key) =>
      attributes[key]?.map((item) => ({
        value: item.organizationAttributesId,
        label: item.attributeValue,
      })) || [];

    setDepartments(extractItems("DEPARTMENT"));
    setLocations(extractItems("LOCATION"));
    setGroups(extractItems("GROUP"));
  };

  useEffect(() => {
    if (attributes) {
      filterAttributes();
    }
  }, [attributes, attributeLoading, attributeError]);

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 font-poppins overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="add-member-page p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="max-w mx-auto">
            <div className="flex items-center justify-between gap-3 mb-3">
              <div className="flex justify-center items-center gap-2">
                <Button
                  className="flex items-center justify-center w-9 h-9 p-0 rounded-xl bg-white border-[1px] border-solid border-[#E2E8F0] shadow-sm hover:bg-[#F8FAFC] text-[#171717]"
                  onClick={() => window.history.back()}
                >
                  <ArrowLeft size={18} />
                </Button>
                <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
                  Add New Member
                </h1>
              </div>
              <Button
                className="flex items-center gap-2 h-9 px-[14px] bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition hover:text-[#171717]"
                onClick={() => setIsModalOpen(true)}
              >
                Bulk Upload
                <img
                  src={IMAGES.export_icon}
                  alt="export_icon"
                  className="w-[16px]"
                />
              </Button>
            </div>
            <div className="w-full p-[24px] bg-[#FFFFFF] border-[1px] border-solid border-[#E2E8F0] shadow-sm rounded-2xl">
              <div className="max-w-4xl ">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleFinish}
                  className="space-y-6 bg-white font-poppins"
                  style={{ background: "transparent" }}
                >
                  <Collapse defaultActiveKey={["1"]} bordered={false}>
                    <Panel header="Basic Information" key="1">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-poppins">
                        <Form.Item name="title" label="Title">
                          <Select
                            placeholder="Select"
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          >
                            <Option value="Mr">Mr</Option>
                            <Option value="Ms">Ms</Option>
                            <Option value="Dr">Dr</Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="firstName"
                          label="First Name"
                          rules={[
                            {
                              required: true,
                              message: "First name is required",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Type here"
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="lastName"
                          label="Last Name"
                          rules={[
                            {
                              required: true,
                              message: "Last name is required",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Type here"
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="email"
                          label="Email ID"
                          rules={[
                            { required: true, message: "Email is required" },
                            { type: "email", message: "Enter a valid email" },
                          ]}
                        >
                          <Input
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="phone"
                          label="Phone Number"
                          rules={[
                            {
                              required: true,
                              message: "Phone number is required",
                            },
                            {
                              pattern: /^[0-9]{10}$/,
                              message: "Enter a valid 10-digit number",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Type here"
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>

                        <Form.Item name="gender" label="Gender">
                          <Select
                            placeholder="Select"
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          >
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                            <Option value="Other">Other</Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="dob"
                          label="Date Of Birth"
                          rules={[
                            {
                              required: true,
                              message: "Date of Birth is required",
                            },
                          ]}
                        >
                          <DatePicker
                            className="w-full h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                            onChange={(date, dateString) =>
                              setDobValue(dateString)
                            }
                            disabledDate={(current) => current && current > moment().endOf('day')}
                          />
                        </Form.Item>

                        <Form.Item
                          label="Institution/Organization"
                          initialValue="KJ Somaniya"
                        >
                          <Input
                            className="h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                            value={localStorage.getItem("orgName")}
                            readOnly
                          />
                        </Form.Item>
                      </div>
                    </Panel>

                    <Panel header="Additional Details" key="2">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-poppins">
                        <Form.Item label="Department" name="department">
                          <Select
                            mode="multiple"
                            allowClear
                            placeholder="Select Department"
                            options={departments}
                            onChange={handleCustomGroupChange}
                            className="w-1/2 h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>
                        <Form.Item label="Location" name="location">
                          <Select
                            mode="multiple"
                            allowClear
                            placeholder="Select Location"
                            options={locations}
                            onChange={handleCustomGroupChange}
                            className="w-1/2 h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>
                        <Form.Item label="Custom Group" name="customGroup">
                          <Select
                            mode="multiple"
                            allowClear
                            placeholder="Select Group"
                            options={groups}
                            onChange={handleCustomGroupChange}
                            className="w-1/2 h-[48px] rounded-xl bg-white shadow-sm text-sm text-[#171717] font-poppins"
                            dropdownClassName="custom-dropdown"
                            style={{ border: "1px solid #E2E8F0" }}
                          />
                        </Form.Item>
                      </div>
                    </Panel>
                  </Collapse>

                  <div className="w-full flex justify-end gap-4">
                    <Button
                      onClick={() => form.resetFields()}
                      className="h-9 px-[14px] bg-white text-[#334155] text-[13px] font-semibold rounded-xl shadow-sm hover:bg-[#F8FAFC] font-poppins"
                      style={{ border: "1px solid #E2E8F0" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      htmlType="submit"
                      type="primary"
                      className="btn-gradient h-9 px-[14px] text-[13px] font-semibold rounded-xl border-0 font-poppins"
                      loading={createMemberLoading}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MemberUpload
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
